/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"PPyFPR":["Searching for a computer program?"],"DQ2JVD":["Browse Projects"],"N40H+G":["All"],"8BlqGC":["Sort by:"],"7dZnmw":["Relevance"],"mYGY3B":["Date"],"2sCKvr":["Refine your search"],"f6e0Ry":["Article"],"50/FGa":["Exercise"],"vSJd18":["Video"],"B9s8AG":["Courses, Units, and Lessons"],"NZOTMD":["AI Activities"],"l8rp1O":["Math"],"5/lolt":["Science"],"v2MbsP":["Economics and finance"],"rlJzsJ":["Arts and humanities"],"bTtZZs":["Computing"],"tM+ydO":["Test prep"],"wOk914":["Partner content"],"7VzPm8":["Life skills"],"J7spMX":["Khan for Educators"],"IbYr/u":["Content type"],"EoKe5U":["Domain"],"Ev2r9A":["No results"],"Q3Fksn":["Try a different search term."],"kcFoMY":["Try clearing your filters."],"+G6nmv":["Khanmigo"],"5WYZKZ":["Search results"],"tI0Z0S":["There was an error retrieving the search results"],"DHhJ7s":["Previous"],"XtRoxT":["Page ",["pageNumber"]],"hXzOVo":["Next"],"8mPsl7":["Not seeing what you're looking for?"],"bMFSVm":["See our Google-powered results"],"vH6wx2":["Back to Khan Academy Search"],"wQL2dl":["Or, try our Google-powered results."],"qJLttu":["Topic"],"2DNE7C":["Course"],"aSwfbR":["Unit"],"nJwqRr":["Lesson"],"KnUKo8":["Curation Page"],"HAQlGl":["AI Activity"],"A1taO8":["Search"],"k3PbH6":["Search page"],"3AVEjm":["We don't have support for searching in your current language, sorry! We've done the search in English instead."],"Bz2rUd":["Search for courses, skills, and videos"]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["zh-hant","sgn-us","is","en-x-rtl","zu","xh","th","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["ur","te","ko","km","uz","ta","sk","rw","pt-pt","my","mr","mn","lv","lt","lol","ky","kn","id","gu","fv","da","as","ar"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
